const DoneIcon = (props: any) => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.9987 20.1667C16.0404 20.1667 20.1654 16.0417 20.1654 11C20.1654 5.95833 16.0404 1.83333 10.9987 1.83333C5.95703 1.83333 1.83203 5.95833 1.83203 11C1.83203 16.0417 5.95703 20.1667 10.9987 20.1667Z"
        stroke={props.stroke || "var(--theme-primary-color, #2E3092)"}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.10547 11L9.69964 13.5942L14.8971 8.40583"
        stroke={props.stroke || "var(--theme-primary-color, #2E3092)"}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export { DoneIcon };
